export const AUTH_RETURN_STORAGE_KEY = "nia_auth_return_target";

export function normalizeAuthReturnTarget(value = "") {
  const candidate = String(value || "").trim();
  if (
    !candidate.startsWith("/") ||
    candidate.startsWith("//") ||
    candidate.includes("\\") ||
    /^\/login(?:[/?#]|$)/i.test(candidate)
  ) {
    return "";
  }
  try {
    const parsed = new URL(candidate, "https://nia.local");
    if (parsed.origin !== "https://nia.local") return "";
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return "";
  }
}

export function locationToAuthReturnTarget(location = {}) {
  return normalizeAuthReturnTarget(
    `${location?.pathname || ""}${location?.search || ""}${location?.hash || ""}`
  );
}

export function readStoredAuthReturnTarget(storage) {
  try {
    return normalizeAuthReturnTarget(storage?.getItem(AUTH_RETURN_STORAGE_KEY) || "");
  } catch {
    return "";
  }
}

export function storeAuthReturnTarget(storage, target = "") {
  const safeTarget = normalizeAuthReturnTarget(target);
  try {
    if (safeTarget) storage?.setItem(AUTH_RETURN_STORAGE_KEY, safeTarget);
    else storage?.removeItem(AUTH_RETURN_STORAGE_KEY);
  } catch {}
  return safeTarget;
}

export function readMarkedPostSessionReturn(searchParams) {
  if (!searchParams || searchParams.get("return") !== "post_session") {
    return null;
  }
  const orgId = String(searchParams.get("org") || "").trim();
  const sessionId = String(searchParams.get("id") || "").trim();
  if (!orgId || !sessionId) return null;
  return { orgId, sessionId };
}

export function buildHydratedSessionTarget({ orgId = "", sessionId = "" } = {}) {
  const safeOrgId = String(orgId || "").trim();
  const safeSessionId = String(sessionId || "").trim();
  if (!safeOrgId || !safeSessionId) return "/chat";
  return (
    `/chat?org=${encodeURIComponent(safeOrgId)}` +
    `&id=${encodeURIComponent(safeSessionId)}`
  );
}
